(() => {
  const init = () => {
    $(window).on('load', function(){
      var w = $(window).width();
      var x = 915;
      if (w <= x) {
        $(".header-footer-group .content .section-inner .right-block").hide();
        $(".section-inner .button-block").removeClass('active');
      } else {
        $(".header-footer-group .content .section-inner .right-block").show();
        $(".section-inner .button-block").addClass('active');
      }
    });

    $(window).resize(function() {
      var w = $(window).width();
      var x = 915;
      if (w <= x) {
      } else {
      $(".header-footer-group .content .section-inner .right-block").show();
      $(".section-inner .button-block").addClass('active');
      }
    });

    $(".section-inner .button-block").click(function()
    {
    $(this).toggleClass('active');
      $(this).next(".right-block").slideToggle(100);
    });

  }
  $(init);
})();
